module.exports = __webpack_public_path__ + "media/packs/images/flags/PG-84c4cc94cd20e9248cd7d52038aad94c.svg";